import { Location } from 'react-router-dom';
import { JobTabKey, JobTabKeys } from './types';
import { JobHistoryTypes } from 'store/jobs/job';

export const getJobDetailsActiveTabKey = (location: Location): JobTabKey => {
    const segments = location.pathname.split('/');
    const potentialTabKey = segments[3] as JobTabKey;

    if (Object.values(JobTabKeys).includes(potentialTabKey)) {
        return potentialTabKey;
    }

    return JobTabKeys.OVERVIEW;
};

export const JobHistoryLabels: Record<JobHistoryTypes, string> = {
    [JobHistoryTypes.CREATED]: 'Created',
    [JobHistoryTypes.UPDATED]: 'Updated',
    [JobHistoryTypes.ADDED_TO_MANIFEST]: 'Added to manifest',
    [JobHistoryTypes.REMOVED_FROM_MANIFEST]: 'Removed from manifest',
    [JobHistoryTypes.CLEARANCE_AGENT_ASSIGNED]: 'Clearance agent assigned',
    [JobHistoryTypes.ARCHIVED]: 'Archived',
    [JobHistoryTypes.UNARCHIVED]: 'Unarchived',
    [JobHistoryTypes.EXTERNAL_REFERENCES_UPDATED]: 'External references updated',
};

export const getHistoryTypeLabel = (type: JobHistoryTypes): string => JobHistoryLabels[type];
